/**
 * @generated SignedSource<<5996c0f971421e29181e3e59a4a4f7c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptModal_PublicClipModal_videoPlaybackSettings$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_videoPlaybackSettings">;
  readonly " $fragmentType": "TranscriptModal_PublicClipModal_videoPlaybackSettings";
};
export type TranscriptModal_PublicClipModal_videoPlaybackSettings$key = {
  readonly " $data"?: TranscriptModal_PublicClipModal_videoPlaybackSettings$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptModal_PublicClipModal_videoPlaybackSettings">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptModal_PublicClipModal_videoPlaybackSettings",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TranscriptVideo_videoPlaybackSettings"
    }
  ],
  "type": "UserVideoPlaybackSettings",
  "abstractKey": null
};

(node as any).hash = "b6e492ab69b2e5633ceb8a211022cc55";

export default node;
